// Este archivo se genera automáticamente por features/routing/generate-route-registry.mjs.
//! No editar manualmente.

import type { RouteRegistryEntry } from '@/features/routing';
import { UserRoles } from '@/features/users';
import { TriangleAlertIcon, OrbitIcon, MapIcon, FileTextIcon, HistoryIcon, UserRoundSearchIcon, BookUserIcon } from 'lucide-react';

export const ROUTE_REGISTRY: RouteRegistryEntry[] = [
  { path: "/anomalies", access: { roles: [UserRoles.USER] }, sidebar: { labelKey: "/anomalies", icon: TriangleAlertIcon, order: 6 } },
  { path: "/dashboard", sidebar: { labelKey: "/dashboard", icon: OrbitIcon, order: 3 } },
  { path: "/map", access: { roles: [UserRoles.USER] }, sidebar: { labelKey: "/map", icon: MapIcon, order: 4 } },
  { path: "/reports", access: { roles: [UserRoles.USER] }, sidebar: { labelKey: "/reports", icon: FileTextIcon, order: 7 } },
  { path: "/signal-history", access: { roles: [UserRoles.USER] }, sidebar: { labelKey: "/signal-history", icon: HistoryIcon, order: 5 } },
  { path: "/user-activity", access: { roles: [UserRoles.ADMIN] }, sidebar: { labelKey: "/user-activity", icon: UserRoundSearchIcon, order: 2 } },
  { path: "/users", access: { roles: [UserRoles.ADMIN] }, sidebar: { labelKey: "/users", icon: BookUserIcon, order: 1 } }
];
